/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraBusinessTimelineAppMemoQuery$parameters.ts';
import type { JiraBusinessTimelineAppMemoQuery } from './__generated__/JiraBusinessTimelineAppMemoQuery.graphql.ts';

type TimelineEntrypointComponent = EntryPointComponent<
	{
		timelineQuery: JiraBusinessTimelineAppMemoQuery;
	},
	{},
	{},
	{}
>;

export const timelineEntrypoint: EntryPoint<TimelineEntrypointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<TimelineEntrypointComponent>(
			/* webpackChunkName: "async-business-timeline-entrypoint" */ './JiraBusinessTimelineAppMemo.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
			const projectKey = context.match.params.projectKey;

			if (projectKey == null) {
				throw new Error('Project key missing');
			}

			return {
				queries: {
					timelineQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters,
						variables: {
							cloudId,
							projectKey,
						},
					},
				},
			};
		},
	});
